import { render, staticRenderFns } from "./TlyncPayments.html?vue&type=template&id=0a8807ce&external"
import script from "./TlyncPayments.js?vue&type=script&lang=js&external"
export * from "./TlyncPayments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports